import { useState, useEffect } from 'react';
import { adminAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { ScrollArea } from '../components/ui/scroll-area';
import { Download } from 'lucide-react';
import { AdminPageShell, EmptyRow } from '../components/AdminShared';

export default function AdminLedgerPage() {
  const [ledger, setLedger] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { adminAPI.getLedger({}).then(r => setLedger(r.data)).catch(console.error).finally(() => setLoading(false)); }, []);

  const exportCSV = () => {
    if (!ledger?.entries) return;
    const csv = [['ID','Org ID','Session ID','Type','Amount (cents)','Description','Created At'].join(','),
      ...ledger.entries.map(e => [e.id, e.org_id, e.session_id, e.entry_type, e.amount_cents, `"${e.description}"`, e.created_at].join(','))].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' }); const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'ledger_export.csv'; a.click();
  };

  return (
    <AdminPageShell
      loading={loading}
      title="Billing Ledger"
      testId="admin-ledger-page"
      actions={<Button variant="outline" size="sm" onClick={exportCSV} data-testid="export-ledger-button"><Download className="w-4 h-4 mr-2" />Export CSV</Button>}
    >
      <div className="flex gap-4 text-sm mb-6">
        <div className="rounded-lg border bg-card px-4 py-2"><span className="text-muted-foreground">Charges: </span><span className="font-mono font-medium">${((ledger?.summary?.total_charges_cents || 0) / 100).toFixed(2)}</span></div>
        <div className="rounded-lg border bg-card px-4 py-2"><span className="text-muted-foreground">Credits: </span><span className="font-mono font-medium text-[hsl(var(--success))]">${(Math.abs(ledger?.summary?.total_credits_cents || 0) / 100).toFixed(2)}</span></div>
        <div className="rounded-lg border bg-card px-4 py-2"><span className="text-muted-foreground">Net: </span><span className="font-mono font-medium">${((ledger?.summary?.net_cents || 0) / 100).toFixed(2)}</span></div>
      </div>
      <div className="rounded-lg border bg-card">
        <ScrollArea className="max-h-[500px]">
          <Table>
            <TableHeader><TableRow>
              <TableHead className="font-mono text-xs">ID</TableHead><TableHead>Type</TableHead><TableHead>Amount</TableHead><TableHead>Description</TableHead><TableHead>Date</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {(ledger?.entries || []).map(e => (
                <TableRow key={e.id}>
                  <TableCell className="font-mono text-xs">{e.id.slice(0, 8)}</TableCell>
                  <TableCell><Badge variant={e.entry_type === 'SLA_CREDIT' ? 'destructive' : 'secondary'} className="text-xs">{e.entry_type}</Badge></TableCell>
                  <TableCell className={`font-mono text-sm ${e.amount_cents < 0 ? 'text-[hsl(var(--success))]' : ''}`}>{e.amount_cents < 0 ? '-' : ''}${(Math.abs(e.amount_cents) / 100).toFixed(2)}</TableCell>
                  <TableCell className="text-sm text-muted-foreground">{e.description}</TableCell>
                  <TableCell className="text-xs text-muted-foreground font-mono">{new Date(e.created_at).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
              {(ledger?.entries || []).length === 0 && <EmptyRow colSpan={5} message="No entries" />}
            </TableBody>
          </Table>
        </ScrollArea>
      </div>
    </AdminPageShell>
  );
}
